export default __webpack_public_path__ + "static/media/plus-dark.1e840783.svg";